import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import useHovered from 'UIComponents/hooks/useHovered';
import { CloseButton } from './CloseButton';
import { Flex } from 'foundations-components/components/Flex';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TabContents = ({
  icon,
  scrollToRef,
  children,
  closeDisabled,
  closeTooltip,
  onCloseClickFunction,
  active,
  isDragDisabled,
  tabId
}) => {
  const _useHovered = useHovered({}),
    hoveredProps = Object.assign({}, (_objectDestructuringEmpty(_useHovered), _useHovered));
  const doShowDragHandle = hoveredProps.hovered && !isDragDisabled;
  const doShowCloseButton = (active || hoveredProps.hovered) && !closeDisabled;
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    paddingBlockStart: "200",
    paddingInlineStart: "400",
    paddingInlineEnd: "200"
  }, hoveredProps, {
    children: [doShowDragHandle && /*#__PURE__*/_jsx(Flex, {
      marginInlineStart: "-200",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(DragHandle, {
        "data-test-id": "tab-contents-drag-handle"
      })
    }), icon, /*#__PURE__*/_jsx(View, {
      as: "span",
      ref: scrollToRef,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: children
      })
    }), doShowCloseButton && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onCloseClickFunction,
      tabId: tabId,
      tooltip: closeTooltip,
      disabled: closeDisabled
    })]
  }));
};